import styled from "styled-components";

const StyledHero = styled.header `
    height: 450px;
    display: flex;
    background: url(${props => props.img}) center/cover no-repeat;
    align-items: center;
`;
export default StyledHero;